import { render } from "./FormNameMobile.vue?vue&type=template&id=58fc6dc3&scoped=true&ts=true"
import script from "./FormNameMobile.vue?vue&type=script&lang=ts"
export * from "./FormNameMobile.vue?vue&type=script&lang=ts"

import "./FormNameMobile.vue?vue&type=style&index=0&id=58fc6dc3&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fc6dc3"]])

export default __exports__